import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["currentMonth", "onMonthChange", "leftArrowIcon", "rightArrowIcon", "disablePrevMonth", "disableNextMonth", "slideDirection", "theme"];
import React from 'react';
import PropTypes from 'prop-types';
import DateUtils from '../../utils/date';
import withTheme from '../../theme/withTheme';
import SlideTransition from '../../Transitions/Slide';
import ArrowLeftIcon from '../../Icons/ArrowLeft';
import ArrowRightIcon from '../../Icons/ArrowRight';
import { SwitchHeader, ArrowButton, MonthLabel, DaysHeader, DayLabel } from './styles';
var utils = new DateUtils();
var CalendarHeader = function CalendarHeader(_ref) {
  var currentMonth = _ref.currentMonth,
    onMonthChange = _ref.onMonthChange,
    leftArrowIcon = _ref.leftArrowIcon,
    rightArrowIcon = _ref.rightArrowIcon,
    disablePrevMonth = _ref.disablePrevMonth,
    disableNextMonth = _ref.disableNextMonth,
    slideDirection = _ref.slideDirection,
    theme = _ref.theme,
    other = _objectWithoutProperties(_ref, _excluded);
  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
  };
  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
  };
  return /*#__PURE__*/React.createElement("div", other, /*#__PURE__*/React.createElement(SwitchHeader, null, /*#__PURE__*/React.createElement(ArrowButton, {
    theme: theme,
    disabled: disablePrevMonth,
    onClick: selectPreviousMonth
  }, leftArrowIcon), /*#__PURE__*/React.createElement(SlideTransition, {
    style: {
      width: '100%',
      height: '20px'
    },
    direction: slideDirection,
    transitionKey: String(currentMonth)
  }, /*#__PURE__*/React.createElement(MonthLabel, {
    theme: theme
  }, utils.getCalendarHeaderText(currentMonth))), /*#__PURE__*/React.createElement(ArrowButton, {
    theme: theme,
    disabled: disableNextMonth,
    onClick: selectNextMonth
  }, rightArrowIcon)), /*#__PURE__*/React.createElement(DaysHeader, {
    theme: theme
  }, utils.getWeekdays('EEE').map(function (day, index) {
    return /*#__PURE__*/React.createElement(DayLabel, {
      theme: theme,
      key: "day-label_".concat(index)
    }, String(day[0]).toUpperCase());
  })));
};
process.env.NODE_ENV !== "production" ? CalendarHeader.propTypes = {
  leftArrowIcon: PropTypes.node,
  rightArrowIcon: PropTypes.node,
  disablePrevMonth: PropTypes.bool,
  disableNextMonth: PropTypes.bool
} : void 0;
CalendarHeader.defaultProps = {
  leftArrowIcon: /*#__PURE__*/React.createElement(ArrowLeftIcon, null),
  rightArrowIcon: /*#__PURE__*/React.createElement(ArrowRightIcon, null),
  disablePrevMonth: false,
  disableNextMonth: false
};
export default withTheme(CalendarHeader);